export const passwordRegex = /^[A-Za-z0-9$!@#%^&*()_+-=[\]{}|;':",\.\/\\<>?~`]{12,}$/

